	var FIGURE = FIGURE || {};
	
	FIGURE.shippingMessage = function() {
		var specialMessageModal = $.cookie('specialmessage');
		if (specialMessageModal == 'read') {
			return;
		} else {
			setTimeout(function(){
				$('#figureMessageModal').modal();
			}, 3000);	
		}	
		$('#figureMessageModal').on('hide.bs.modal', function (event) {
			$.cookie('specialmessage', 'read', { path: '/' });
		});
		$('#figureMessageModal a').click(function() {
			$.cookie('specialmessage', 'read', { path: '/' });
		});
	}();
	
	$.fn.isInViewport = function(offset = 0) {
		var elementTop = $(this).offset().top;
		var elementBottom = elementTop + $(this).outerHeight();
	
		var viewportTop = $(window).scrollTop() - offset;
		var viewportBottom = viewportTop + $(window).height();
	
		return elementBottom > viewportTop && elementTop < viewportBottom;
	};
	
	FIGURE.BirdAnimator = function() {
		$(window).on('load scroll resize', function() {
			$('.footer-bird-container').each(function() {
				const bird = $(this).find('.footer-bird-image');
				if ($(this).isInViewport(300)) {
					bird.addClass('in-view');
				} else if (!$(this).isInViewport(0)) {
					bird.removeClass('in-view');
				}
			});
		});
	}();
	
	FIGURE.images = function() {
		function observeImages() {
			const imageObserver = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						const img = entry.target;
						const $img = $(img);
	
						// Check if already loaded
						if (img.complete && img.naturalWidth > 0) {
							$img.addClass("loaded");
							imageObserver.unobserve(img); // Stop observing this image
						} else {
							// Wait for it to load
							img.addEventListener('load', function() {
								$img.addClass("loaded");
								imageObserver.unobserve(img); // Stop observing this image
							}, { once: true });
	
							// Handle load errors
							img.addEventListener('error', function() {
								$img.addClass("error");
								imageObserver.unobserve(img);
							}, { once: true });
						}
					}
				});
			}, {
				// Trigger when 10% of the image is visible
				threshold: 0.1,
				// Start observing 50px before the image enters viewport
				rootMargin: '50px'
			});
	
			// Function to observe all images (including new ones)
			function observeAllImages() {
				$("img").each(function() {
					// Only observe if not already being observed
					if (!this.dataset.observed) {
						this.dataset.observed = 'true';
						imageObserver.observe(this);
					}
				});
			}
	
			// Observe existing images
			observeAllImages();
	
			// Watch for new images being added to DOM
			const mutationObserver = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					if (mutation.addedNodes.length) {
						mutation.addedNodes.forEach(function(node) {
							if (node.nodeType === 1) {
								const $newImages = $(node).find('img').addBack('img');
								if ($newImages.length > 0) {
									observeAllImages(); // Observe the new images
								}
							}
						});
					}
				});
			});
	
			mutationObserver.observe(document.body, {
				childList: true,
				subtree: true
			});
		}
	
	// Initialize when DOM is ready
		$(document).ready(observeImages);
	
		// For Lazy Load Carousels
		$(document).ready(function() {
			// Preload first slide immediately
			loadSlideImage($('.carousel-item.active')[0]);
	
			// Bootstrap 4.6 uses different event names
			$('.image-set-carousel').on('slide.bs.carousel', function(e) {
				loadSlideImage(e.relatedTarget);
			});
	
			// Optional: Preload all images on page load
			preloadAllSlides();
		});
	
		async function loadSlideImage(slideElement) {
			const $slide = $(slideElement);
			const $bgDiv = $slide.find('.carousel-bg');
			const imageUrl = $slide.data('bg');
	
			// Bail out if there's nothing to load, or we've already loaded
			if (!imageUrl || $bgDiv.hasClass('loaded') || $bgDiv.length === 0) return;
	
			try {
				await loadImage(imageUrl);
				$bgDiv.css({'background-image': `url(${imageUrl})`});
				$bgDiv.addClass('loaded');
			} catch (error) {
				console.error('Image failed to load:', error);
			}
	
		}
		function loadImage(imageUrl) {
			return new Promise((resolve, reject) => {
				const img = new Image();
				img.onload = () => {
					// console.log(`✅ Image loaded successfully: ${imageUrl}`);
					resolve(img);
				}
				img.onerror = (e) => {
					// console.error(`❌ Image failed to load: ${imageUrl}`);
					// console.error('Error details:', e);
					// console.error('Image src:', this.src);
					// console.error('Image complete:', this.complete);
					// console.error('Image naturalWidth:', this.naturalWidth);
					reject(e);
				}
				img.src = imageUrl;
			});
		}
	
	// Optional: Preload all images at once
		function preloadAllSlides() {
			$('.carousel-item').each(function() {
				loadSlideImage(this);
			});
		}
	}();
	
	FIGURE.navStuff = function() {
		$(window).on("scroll resize", function() {
			if (!$("body").hasClass('.headroom--pinned') && $(".dropdown-nav").hasClass("show")) {
				$(".dropdown-nav").dropdown('hide')
			}
		});
		$(document).on("click", ".dropdown-nav .dropdown-item", function(e) {
			e.preventDefault();
			const href = $(this).attr("href");
			window.location = href;
		});
	}();
	
	FIGURE.signupForm = function() {
		// Part 1 - Sign up shortcut
		$('.mailing-list').on('submit', e => {
			e.preventDefault();
			let inputs = [];
			$(".mailing-list input:not(button)").each((index, input) => {
				const name = $(input).attr('id');
				const value = $(input).val();
				if (value) {
					inputs.push(name + '=' + value);
				}
			});
			if (inputs.length) {
				let action = $(e.target).attr('action') + '?' + inputs.join('&');
				window.location.href = action;
			}
		});
	
		// Part 2 - Fill Out Form
		if ($('#signupForm').length) {
			const url = window.location.href;
			if (url.indexOf('?') > -1) {
				const inputs = url.split('?')[1].split('&');
				inputs.map(input => {
					const name = input.split('=')[0];
					const value = input.split('=')[1];
					$(`#${name}`).val(value);
				})
			}
		}
	}();
